export const aIChatPlaygroundContext = {
	value: '',
	setValue: (context: string) => {
		aIChatPlaygroundContext.value = context;
	},
};

export const aIChatPlaygroundResetModalId = 'aIChatPlaygroundResetModalId';

export const aIChatPlaygroundErrorModalId = 'aIChatPlaygroundErrorModalId';

export const loadingMessages = [
	'ai-chat.loading.message-1',
	'ai-chat.loading.message-2',
	'ai-chat.loading.message-3',
	'ai-chat.loading.message-4',
	'ai-chat.loading.message-5',
];

export const maxInputLength = 2000;

export enum ClickType {
	Maximize = 'MAXIMIZE',
	Collapse = 'COLLAPSE',
	TryAgain = 'TRY AGAIN',
	CopyPrompt = 'COPY PROMPT',
	SettingsGuide = 'SETTINGS GUIDE',
	AIChatTab = 'AI CHAT TAB',
	SettingsTab = 'SETTINGS TAB',
	SuggestedPrompt = 'SUGGESTED PROMPT',
	FreeTextboxInput = 'FREE TEXTBOX INPUT',
	Regenerate = 'REGENERATE',
}

export enum ResetClickType {
	ResetButtonClick = 'RESET BUTTON CLICK',
	ConfirmReset = 'CONFIRM RESET',
	CancelReset = 'CANCEL RESET',
}
